/* MoRetro Studio V5 — Files */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  function cleanFileName(name){
    return String(name || "fichier")
      .normalize("NFD").replace(/[\\u0300-\\u036f]/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "-")
      .replace(/-+/g, "-")
      .slice(0, 120);
  }

  function getExt(name){
    const n = String(name || "").toLowerCase();
    const i = n.lastIndexOf(".");
    return i >= 0 ? n.slice(i) : "";
  }

  function isImageFile(f){
    return String(f.type || "").startsWith("image/") || /\.(jpg|jpeg|png|webp)$/i.test(String(f.name || ""));
  }

  function category(f){
    const n = String(f.name || "").toLowerCase();
    if(isImageFile(f)) return "image";
    if(/\.(stl|3mf|obj|gcode|bgcode|step|stp|amf|ply|wrl|x3d)$/i.test(n)) return "3d";
    if(/\.pdf$/i.test(n)) return "pdf";
    if(/\.(zip|rar|7z)$/i.test(n)) return "archive";
    return "other";
  }

  function fileIcon(file){
    const ext = String(file.ext || file.name || "").toLowerCase();
    if(ext.includes(".stl") || ext.endsWith("stl")) return "🧊";
    if(ext.includes(".3mf") || ext.endsWith("3mf")) return "🟪";
    if(ext.includes(".obj") || ext.endsWith("obj")) return "🔺";
    if(ext.includes(".gcode") || ext.endsWith("gcode") || ext.endsWith("bgcode")) return "🧵";
    if(ext.includes(".step") || ext.includes(".stp") || ext.endsWith("step") || ext.endsWith("stp")) return "📐";
    if(ext.includes(".amf") || ext.endsWith("amf") || ext.endsWith("ply") || ext.endsWith("wrl") || ext.endsWith("x3d")) return "📦";
    if((file.type||"").startsWith("image/")) return "🖼️";
    return "📎";
  }

  function fileSizeLabel(bytes){
    const n = Number(bytes || 0);
    if(!n) return "";
    if(n < 1024*1024) return Math.round(n/1024) + " Ko";
    return (n/(1024*1024)).toFixed(1).replace(".", ",") + " Mo";
  }

  async function uploadProjectFiles(projectId, input){
    const files = Array.from(input && input.files ? input.files : []);
    if(!files.length) throw new Error("Aucun fichier sélectionné.");

    const max = 50 * 1024 * 1024;
    for(const f of files){
      if(f.size > max) throw new Error("Fichier trop lourd : " + f.name + ". Maximum 50 Mo.");
    }

    const uploaded = [];

    for(const file of files){
      const safeName = cleanFileName(file.name);
      const path = `custom_requests/${projectId}/${Date.now()}-${safeName}`;
      const ref = MTS.state.storage.ref().child(path);

      await ref.put(file, {
        contentType:file.type || "application/octet-stream",
        customMetadata:{originalName:file.name}
      });

      const url = await ref.getDownloadURL();

      uploaded.push({
        name:file.name,
        safeName,
        path,
        url,
        type:file.type || "application/octet-stream",
        ext:getExt(file.name),
        size:file.size,
        category:category(file),
        addedBy:"studio",
        addedAt:new Date().toISOString()
      });
    }

    const project = MTS.state.projects.find(p=>p.id===projectId) || {};
    const current = Array.isArray(project.files) ? project.files : [];

    await MTS.state.db.collection("custom_requests").doc(projectId).update({
      files:current.concat(uploaded),
      fileCount:current.length + uploaded.length,
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history: firebase.firestore.FieldValue.arrayUnion({
        type:"files_added",
        label: uploaded.length + " fichier(s) ajouté(s)",
        date:new Date().toISOString()
      })
    });
  }

  function renderFiles(files){
    if(!Array.isArray(files) || !files.length){
      return '<div class="mts-request-files"><span>Fichiers</span><div class="mts-empty">Aucun fichier.</div></div>';
    }

    const previews = files.filter(isImageFile).slice(0,6);

    return `
      <div class="mts-request-files">
        <span>Fichiers joints</span>
        <div class="mts-file-list">
          ${files.map(f=>`
            <div class="mts-file-item">
              <div class="mts-file-info">
                <div class="mts-file-icon">${fileIcon(f)}</div>
                <div>
                  <strong class="mts-file-name">${MTS.escapeHtml(f.name || "Fichier")}</strong>
                  <span class="mts-file-meta">${MTS.escapeHtml(f.type || "fichier")} ${f.size ? "• " + MTS.escapeHtml(fileSizeLabel(f.size)) : ""}</span>
                </div>
              </div>
              ${f.url ? `<a class="mts-btn mts-soft mts-file-download" href="${MTS.escapeHtml(f.url)}" target="_blank" rel="noopener">Télécharger</a>` : ""}
            </div>
          `).join("")}
        </div>
        ${previews.length ? `<div class="mts-file-preview">${previews.map(f=>`<img src="${MTS.escapeHtml(f.url)}" alt="${MTS.escapeHtml(f.name||"Image")}" loading="lazy">`).join("")}</div>` : ""}
      </div>
    `;
  }

  function renderUploader(){
    return `
      <div class="mts-file-uploader">
        <h4>➕ Ajouter des fichiers au projet</h4>
        <p>Ajoute un STL modélisé, une nouvelle version, un GCODE final, une photo ou un PDF.</p>
        <input type="file" id="mtsAddProjectFiles" multiple accept=".stl,.3mf,.obj,.gcode,.bgcode,.step,.stp,.amf,.ply,.wrl,.x3d,.jpg,.jpeg,.png,.webp,.pdf,.zip">
        <div class="mts-actions">
          <button type="button" class="mts-btn mts-ok" id="mtsUploadProjectFiles">Uploader dans le projet</button>
        </div>
      </div>
    `;
  }

  function bindUpload(project){
    MTS.on("mtsUploadProjectFiles","click",async()=>{
      const input = MTS.$("mtsAddProjectFiles");
      const btn = MTS.$("mtsUploadProjectFiles");

      if(btn) btn.disabled = true;

      try{
        await uploadProjectFiles(project.id, input);
        if(input) input.value = "";
      }catch(err){
        alert("Erreur upload : " + err.message);
      }finally{
        if(btn) btn.disabled = false;
      }
    });
  }

  MTS.Files = {
    uploadProjectFiles,
    renderFiles,
    renderUploader,
    bindUpload,
    isImageFile,
    fileIcon,
    fileSizeLabel
  };

})(window.MTS);


